import React from "react";
import _ from "lodash";
//Controls
import { FormGroup, Input, Label } from "reactstrap";

//Components
import ErrorMessage from "./ErrorMessage";

const InputForm = ({
  label,
  prepend,
  onPrependClick,
  noMargin,
  //Formik
  field,
  form,
  innerRef,
  //Others
  className,
  ...props
}) => {
  const error = _.get(form.errors, field.name);
  return (
    <div
      className={`${prepend ? "input-group" : "form-group"} form-label-group${
        noMargin ? " m-0" : ""
      }`}
    >
      <Input
        className={`border-bottom ${
          error && typeof error == "string" ? "border-danger" : ""
        } ${className}`}
        onChange={(e) => {
          form.setFieldValue(field.name, e.currentTarget.value);
          form.setFieldTouched(field.name, true);
        }}
        onBlur={() => form.setFieldTouched(field.name, true)}
        value={field.value || ""}
        {...props}
      />
      <Label for={props.id}>{label}</Label>
      {prepend && (
        <a
          className={`input-group-prepend ${error ? "error" : ""}`}
          onClick={onPrependClick}
        >
          <span className="input-group-text">{prepend}</span>
        </a>
      )}
      <ErrorMessage error={error} />
    </div>
  );
};

export default InputForm;
